import { styled } from 'styled-components';

import { mq, flexColumn, rowXBetweenYCenter } from '@/shared/ui/styled';

export const StyledDetailsPayment = styled.div`
    hr {
        border: 0;
        border-top: 1px solid ${({ theme }) => theme.color.neutral400};
    }
`;

export const StyledDetailsPaymentPaid = styled.p`
    font-size: ${({ theme }) => theme.fontSize.sm};
    font-weight: 500;
    color: ${({ theme }) => theme.color.grey};
    margin-top: 16px;
`;

export const StyledDetailsPaymentCost = styled.p`
    font-size: ${({ theme }) => theme.fontSize.sm};
    font-weight: 500;
    margin-bottom: 16px;
`;

export const StyledDetailsPaymentReturnPledge = styled.p`
    font-size: ${({ theme }) => theme.fontSize.sm};
    font-weight: 500;
    margin-bottom: 7px;
`;

export const StyledDetailsPaymentInfo = styled.span`
    display: inline-block;
    font-size: ${({ theme }) => theme.fontSize.xs};
    width: 216px;
`;

export const StyledDetailsPaymentBillTitle = styled.h4`
    font-size: ${({ theme }) => theme.fontSize.md};
    font-weight: 500;
    margin: 32px 0 16px;
`;

export const StyledDetailsExtendRentTitle = styled.h4`
    font-size: ${({ theme }) => theme.fontSize.md};
    font-weight: 500;
    margin: 24px 0 16px;
`;

export const StyledDetailsPaymentBillByCash = styled.div`
    ${rowXBetweenYCenter};
    margin-bottom: 16px;

    & > div {
        ${flexColumn};
        & p {
            font-size: ${({ theme }) => theme.fontSize.xs};
            color: ${({ theme }) => theme.color.grey};

            &:first-child {
                margin-bottom: 7px;

                ${mq.lt.md} {
                    ${flexColumn};
                    & span {
                        margin-bottom: 6px;
                    }
                }
            }

            & span {
                font-size: ${({ theme }) => theme.fontSize.sm};
                font-weight: 500;
                color: ${({ theme }) => theme.color.dark};
                margin-right: 6px;
            }
        }
    }

    & button.no-mr .icon {
        margin-right: 0 !important;
    }

    a {
        display: flex;
        gap: 10px;
        align-items: center;
    }
    ${mq.lt.sm} {
        & button {
            & .icon {
                margin-right: 0 !important;
            }

            & span.text-hide {
                display: none;
            }
        }
    }
`;
